import useI18n from '@/hooks/useI18n';
import { batchSuccessModal } from '@/utils/utils';
import { useModel } from '@umijs/max';
import { find, has, isEmpty } from 'lodash';
import NewConnection from './components/business/NewConnection';

const useMemberColumns = () => {
  const { formatMessage } = useI18n();
  const searchPlaceholder = formatMessage('memberMgr.mobileNumber');
  const tableTitle = null;
  const customEventNew: any = (componentRef: any) => [];
  const getICCD = () => [];
  const getStateDate = () => [];
  return {
    searchPlaceholder,
    tableTitle,
    getICCD,
    getStateDate,
    customEventNew,
  };
};

const useMemberCommon = () => {
  const customDetailTabs: any = [];

  return {
    customDetailTabs,
  };
};

const isBtnDisable = (el: any, selectedRows: any) => {
  if (el.subsEventId === 392) {
    return false;
  }
  if (isEmpty(selectedRows)) {
    return true;
  }
  const isPrimary = find(selectedRows[0].subsRelas || [], (item) =>
    has(item, 'bindTypeNDto'),
  )?.bindTypeNDto?.isPrimary;
  if (el.subsEventId === 329 && isPrimary === 'Y') {
    return true;
  }
  const currentServType = selectedRows[0].servType;
  const currenMemberType = selectedRows[0].memberType;
  const servTypeList = el.servTypeList || [];
  const accessObj = find(el?.servTypeAccessLevelList || [], [
    'servType',
    selectedRows[0].servType,
  ]);

  return !(
    servTypeList?.includes(currentServType) &&
    (accessObj?.bcAccessLevel?.includes(currenMemberType) ||
      isEmpty(accessObj?.bcAccessLevel))
  );
};

const useGrade = () => {
  const { queryGrade } = useModel('MemberMgr.memberModel');
  return {
    queryGrade,
  };
};

const customEvent: any = (componentRef: any) => [
  {
    key: 'newConnection',
    content: <NewConnection ref={componentRef} />,
  },
];

const suspendActionCustom = (field?: any, form?: any) => {
  if (field.value === '68') {
    form.setFieldState('effDate', (field: any) => (field.hidden = true));
    form.setFieldState(
      'autoReactiveDate',
      (field: any) => (field.hidden = true),
    );
  } else {
    form.setFieldState('effDate', (field: any) => (field.hidden = false));
    form.setFieldState(
      'autoReactiveDate',
      (field: any) => (field.hidden = false),
    );
  }
};

const useBatchSuccessModal = () => {
  const { formatMessage } = useI18n();
  const commonBatchSuccessModal = (value: any) => {
    batchSuccessModal(formatMessage('memberMgr.operateSuccess'));
  };

  return { commonBatchSuccessModal };
};

export default {
  isNeedIccId: false,
  isNeedExport: false,
  rowSelectionType: 'radio',
  isQueryServType: true,
  isBatchOperation: false,
  isNeedOTC: true,
  isneedCheckMsisdn: true,
  isneedNewConnect: true,
  customEvent,
  isneedShowMemberType: false,
  isNeedOfferDetailModal: false, // 是否需要展示offer图片和描述等信息（做产品和tm用，um不用）
  isNeedBatchSIMReplacement: false, // 批量SIM替换(做产品和tm用，um不用）
  suspendActionCustom,
  isBtnDisable,
  useMemberColumns,
  useMemberCommon,
  useGrade,
  useBatchSuccessModal,
};
